var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account_box" },
    [
      _c("div", { staticClass: "title_box" }, [_vm._v("超级补贴活动管理")]),
      _vm._v(" "),
      _c("div", { staticClass: "content_box mt20" }, [
        _c(
          "div",
          { staticClass: "search_criteria" },
          [
            _c("el-input", {
              attrs: { placeholder: "输入活动名称查询", clearable: "" },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.onInquire($event)
                },
              },
              model: {
                value: _vm.queryData.name,
                callback: function ($$v) {
                  _vm.$set(_vm.queryData, "name", $$v)
                },
                expression: "queryData.name",
              },
            }),
            _vm._v(" "),
            _c(
              "el-select",
              {
                attrs: { placeholder: "选择活动状态", clearable: "" },
                model: {
                  value: _vm.queryData.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.queryData, "status", $$v)
                  },
                  expression: "queryData.status",
                },
              },
              [
                _c("el-option", { attrs: { value: 0, label: "未开始" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: 1, label: "进行中" } }),
                _vm._v(" "),
                _c("el-option", { attrs: { value: 2, label: "已结束" } }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btn_group" },
              [
                _c(
                  "el-button",
                  { attrs: { type: "primary" }, on: { click: _vm.onInquire } },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "info", plain: "" },
                    on: { click: _vm.onInitialize },
                  },
                  [_vm._v("重置")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "add_btn",
                attrs: { type: "primary", plain: "" },
                on: { click: _vm.onAdd },
              },
              [_vm._v("新建+\n      ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content_box mt20" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "header-cell-style": { textAlign: "center" },
                "cell-style": { textAlign: "center" },
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: "活动名称",
                  prop: "name",
                  "min-width": "160",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "头图", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.headPic
                          ? _c("el-image", {
                              staticClass: "head_pic",
                              attrs: {
                                src: scope.row.headPic,
                                "preview-src-list": [scope.row.headPic],
                                fit: "cover",
                              },
                            })
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "用户类型",
                  prop: "userTypeName",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "活动时间", "min-width": "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.startTime))]),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(scope.row.endTime))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "活动状态", width: "110" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", { class: "status_" + scope.row.status }, [
                          _vm._v(_vm._s(scope.row.statusName)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "创建时间",
                  prop: "createTime",
                  "min-width": "180",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "260" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.copyLink(scope.row)
                              },
                            },
                          },
                          [_vm._v("复制链接\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.onEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.onDelete(scope.row)
                              },
                            },
                          },
                          [_vm._v("删除\n          ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page_box" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryData.page,
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.queryData.size,
                  layout: "total, prev, pager, next, sizes, jumper",
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "活动" + (_vm.eventsType === "add" ? "添加" : "编辑"),
            visible: _vm.dialogVisible,
            width: "65%",
            top: "3%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.handleClose,
          },
        },
        [
          _vm.dialogVisible
            ? _c(
                "div",
                { staticClass: "fc" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      staticClass: "rule_form",
                      attrs: {
                        model: _vm.ruleForm,
                        rules: _vm.rules,
                        "label-width": "160px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动名称：", prop: "name" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入" },
                            model: {
                              value: _vm.ruleForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "name", $$v)
                              },
                              expression: "ruleForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "头图：", prop: "headPic" } },
                        [
                          _c(
                            "div",
                            { staticClass: "upload_box" },
                            [
                              _c(
                                "el-upload",
                                {
                                  staticClass: "avatar-uploader",
                                  attrs: {
                                    action: "",
                                    "show-file-list": false,
                                    "http-request": _vm.handleFileUpload,
                                  },
                                },
                                [
                                  _vm.ruleForm.headPic
                                    ? _c("el-image", {
                                        staticClass: "upload_img",
                                        attrs: {
                                          src: _vm.ruleForm.headPic,
                                          "preview-src-list": [
                                            _vm.ruleForm.headPic,
                                          ],
                                          fit: "cover",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                          },
                                        },
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "el-icon-plus avatar-uploader-icon",
                                      }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.ruleForm.headPic
                                ? _c("i", {
                                    staticClass: "el-icon-error clear_icon",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        _vm.ruleForm.headPic = ""
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload_tip" }, [
                            _vm._v("注：建议尺寸750px*320px"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户类型：", prop: "userType" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: _vm.userTypeDisabled },
                              on: { change: _vm.onUserTypeChange },
                              model: {
                                value: _vm.ruleForm.userType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "userType", $$v)
                                },
                                expression: "ruleForm.userType",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("新用户"),
                                _c("span", { staticClass: "radio_tip" }, [
                                  _vm._v("（注册后未出单）"),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 2 } }, [
                                _vm._v("所有人"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 3 } }, [
                                _vm._v("已提现用户"),
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: 4 } }, [
                                _vm._v("指定等级"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.ruleForm.userType === 4
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "userGrade" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.userTypeDisabled,
                                    filterable: "",
                                    clearable: "",
                                    placeholder: "请选择等级",
                                  },
                                  model: {
                                    value: _vm.ruleForm.userGrade,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm, "userGrade", $$v)
                                    },
                                    expression: "ruleForm.userGrade",
                                  },
                                },
                                _vm._l(_vm.gradeOption, function (item) {
                                  return _c("el-option", {
                                    key: item.grade,
                                    attrs: {
                                      label: item.name,
                                      value: item.grade,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "背景色值：", prop: "bgColor" } },
                        [
                          _c(
                            "div",
                            { staticClass: "bg_color_box" },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "#F8F8F8" },
                                model: {
                                  value: _vm.ruleForm.bgColor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "bgColor", $$v)
                                  },
                                  expression: "ruleForm.bgColor",
                                },
                              }),
                              _vm._v(" "),
                              _c("el-color-picker", {
                                staticClass: "ml10",
                                model: {
                                  value: _vm.ruleForm.bgColor,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "bgColor", $$v)
                                  },
                                  expression: "ruleForm.bgColor",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload_tip" }, [
                            _vm._v("默认背景色 #F8F8F8"),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动时间：", prop: "timeArray" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "picker-options": _vm.pickerOptions,
                              type: "datetimerange",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                              "default-time": ["00:00:00", "23:59:59"],
                            },
                            model: {
                              value: _vm.ruleForm.timeArray,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "timeArray", $$v)
                              },
                              expression: "ruleForm.timeArray",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "活动规则文案：", prop: "ruleTxt" } },
                        [
                          _vm.dialogVisible
                            ? [
                                _c(
                                  "div",
                                  { staticClass: "editor_box" },
                                  [
                                    _c("Toolbar", {
                                      staticStyle: {
                                        "border-bottom": "1px solid #ccc",
                                      },
                                      attrs: {
                                        editor: _vm.editor,
                                        "default-config": _vm.toolbarConfig,
                                        mode: _vm.mode,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("Editor", {
                                      staticStyle: {
                                        height: "250px",
                                        "overflow-y": "hidden",
                                      },
                                      attrs: {
                                        "default-config": _vm.editorConfig,
                                        mode: _vm.mode,
                                      },
                                      on: { onCreated: _vm.onCreated },
                                      model: {
                                        value: _vm.ruleForm.ruleTxt,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "ruleTxt", $$v)
                                        },
                                        expression: "ruleForm.ruleTxt",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                loading: _vm.saveLoading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.submitForm("ruleForm")
                                },
                              },
                            },
                            [_vm._v("确认\n          ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.resetForm("ruleForm")
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }